import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import BugReportIcon from '@mui/icons-material/BugReport';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import { Tooltip } from "@mui/material";
import NestJs from "../../common/technologies/nestjs";
import Laravel from "../../common/technologies/laravel";
import Python from "../../common/technologies/python3";
import MongoDb from "../../common/technologies/mongodb";
import Postgre from "../../common/technologies/postgre";
import MySQL from "../../common/technologies/mysql";
import Sqlite from "../../common/technologies/sqlite";
import CartesiRollups from "../../common/technologies/cartesi-rollups";
import Grpc from "../../common/technologies/grpc";
import Queue from "../../common/technologies/queue";
import Sendgrid from "../../common/technologies/sendgrid";
import Sns from "../../common/technologies/sns";
import Redis from "../../common/technologies/redis";
import Php from "../../common/technologies/php";
import Nodejs from "../../common/technologies/nodejs";
import Restapi from "../../common/technologies/restapi";
import Typescript from "../../common/technologies/typescript";
import Docker from "../../common/technologies/docker";
import Ubuntu from "../../common/technologies/ubuntu";
import Git from "../../common/technologies/git";
import GitHub from "../../common/technologies/github";

function PersonalInfo() {
  return (
    <div className={'container'}>
      <img className={'pi-background'} alt={'Background'} src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/master/posts/portfolio/background_personal_info.jpg'}></img>
      <div className={'pi-group'}>
        <div className={'pi-avatar'}></div>
        <div className={'pi-detail-info'}>
          <div className={'pi-basic-info'}>
            <div className={'pi-full-name'}>Nguyễn Tiến Mạnh</div>
            <div className={'pi-position'}>Backend Engineer</div>
            <div className={'pi-email'}>nguyentienmanh6@gmail.com</div>
          </div>
          <div className={'pi-social-media'}>
            Social media:
            <Tooltip title={'Facebook'} placement={'top'}>
              <a href={'https://www.facebook.com/tienmanh2208'} target={'_blank'} rel={'noreferrer'}><FacebookIcon color={'primary'}/></a>
            </Tooltip>
            <Tooltip title={'Linkedin'} placement={'top'}>
              <a href={'https://www.linkedin.com/in/manh-nguyen-93a830165/'} target={'_blank'} rel={'noreferrer'}><LinkedInIcon color={'primary'}/></a>
            </Tooltip>
            <Tooltip title={'Instagram'} placement={'top'}>
              <a href={'https://www.instagram.com/tienmanh_tm'} target={'_blank'} rel={'noreferrer'}><InstagramIcon color={'primary'}/></a>
            </Tooltip>
            <Tooltip title={'Spiderum'} placement={'top'}>
              <a href={'https://spiderum.com/nguoi-dung/tienmanh2208'} target={'_blank'} rel={'noreferrer'}><BugReportIcon color={'primary'}/></a>
            </Tooltip>
            <Tooltip title={'Personal website'} placement={'top'}>
              <a href={'https://depressed-developer.vercel.app'} target={'_blank'} rel={'noreferrer'}><CoPresentIcon color={'primary'}/></a>
            </Tooltip>
            <Tooltip title={'Hackerrank'} placement={'top'}>
              <a href={'https://www.hackerrank.com/nguyentienmanh6'} target={'_blank'} rel={'noreferrer'}><MilitaryTechIcon color={'primary'}/></a>
            </Tooltip>
          </div>
          <div className={'pi-description'}>
            Welcome to my portfolio. My name is Manh and I'm 25 years old.
            I graduated from Hanoi University of Science and Technology with a degree in Software Engineering in 2020.
            Currently, I'm a Backend Developer, and being known as a careful, empathetic, open-minded software engineer, and I always eager to learn something new.
            With 3 years of experience in information technology industry, I have developed strong skill set in Javascript, Typescript, PHP, Python, SQL, NoSQL.
            Also, I care deeply about tuning database performance, optimizing algorithms and designing architecture.
            As a software engineer, I always strive to develop high-quality products for end-users, improve and tune the performance of the system.
            I spend a lot of time to solve algorithms in hackerrank, learning about the new architecture of big systems, and digging deeper into the core logic of the DBMS.<br/>
            In this portfolio, you can find a collection of my most recent work, activities and highlighted projects. Feel free to reach out to me with any questions or opportunities.
          </div>
          <div className={'pi-detail-skills'}>
            Technical skills:
            <div><NestJs/><Laravel/><Python/><Php/><Nodejs/><Typescript/></div>
            <div><MongoDb/><Postgre/><MySQL/><Sqlite/><Redis/></div>
            <div><Restapi/><Docker/><Ubuntu/><Git/><GitHub/><CartesiRollups/><Grpc/><Queue/><Sendgrid/><Sns/></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PersonalInfo;
